import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import PdfViewer from "../../ContentsViewer/Files/PdfViewer";
import { addPdfSlides } from "../../Editor/db";
import { uuidv4 } from "../../Editor/utils";
import ImageUploadPopup from "../UploadPopup/ImageUploadPopup/ImageUploadPopup";
import classes from "./PdfEditor.module.css";

const PdfEditor=({data,addListOfContents,slideId})=>{
    const [showImageUploadPopup, setShowImageUploadPopup] = useState();
    
    const { texts } = useSelector(state => state.translate);

    const makeImage = (page) => {
        const vp = page.getViewport({ scale: 1 });
        const canvas = document.createElement("canvas");
        const scale = 1;
        canvas.width = vp.width;
        canvas.height = vp.height;
        return page.render({ canvasContext: canvas.getContext("2d"), viewport: page.getViewport({ scale: scale }) }).promise.then(function () {
            const img = canvas.toDataURL('image/png')
            return img;
        });
    }

    const createSlidesFromPdfFile = async (values) => {
            const doc = await window.pdfjsLib.getDocument(values.url).promise;
            const pagesArr = await Promise.all([...new Array(doc.numPages)].map(async (x, num) => {
                // const page = await doc.getPage(num + 1);
                // const imageSrc = await makeImage(page);
                // const imageBlob = await fetch(imageSrc).then(r => r.blob());
                // const imageUrl = URL.createObjectURL(imageBlob);
                return {
                    type: "file",
                    name: "" ,
                    data: {...data,pageNum:num+1},
                    id:uuidv4()
                }
            }))
            console.log(pagesArr);
            addPdfSlides(pagesArr,slideId,values.url)
            addListOfContents(pagesArr);
            setShowImageUploadPopup(false)
    }

    return <div className={classes.PdfEditor}> 
        <button className={classes.Btn} onClick={() => setShowImageUploadPopup(true)}>{texts.createSeparateSlides}</button>
        {showImageUploadPopup && <ImageUploadPopup initValues={{url:data.url}} addCallback={createSlidesFromPdfFile} close={() => setShowImageUploadPopup(false)} />}
        <div className={classes.Viewer}><PdfViewer data={data}></PdfViewer></div>
    </div>
}

export default PdfEditor;